export default {
  'ROBOT:EXCEPTION': 'โอ๊ะโอ! เกิดความขัดข้องจากทางเรา ขอโทษด้วยนะ',
  'ROBOT:NOANSWER':
    'ขอโทษนะ ฉันไม่เข้าใจคำถามของคุณ ช่วยเรียบเรียงคำถาม หรือถามแบบอื่นได้มั้ย?',
  'ROBOT:SUGGEST': 'ฉันเดาว่าคุณต้องการจะพูดว่า:',
  'LOGIN:SUCCESS': 'เย้! คุณเข้าสู่ระบบเรียบร้อย!',
  'KNOWLEDGE:GOOD': 'ให้ฉันช่วยอะไรอีกมั้ย?',
  'KNOWLEDGE:BAD':
    'ดูเหมือนฉันจะตอบไม่ตรงคำถาม คุณอยากลองถามอีกรอบ หรือถามอย่างอื่นมั้ย?',
  'SHIPPING:ADDRESS': 'ที่อยู่สำหรับการจัดส่ง',
  'ROBOT:RECOMMEND': 'คุณยังต้องการทราบข้อมูลต่อไปนี้หรือไม่:',
  'ROBOT:RECOMMEND:RELATED': 'บางทีคำแนะนำต่อไปนี้อาจเกี่ยวข้องกับคำถามของคุณ:',
  'TRACKING:DETAIL': 'ตรวจสอบสถานะจัดส่ง',
  'ORDER:STATUS': 'สถานะคำสั่งซื้อ',
  'CANCEL:ITEM': 'ยกเลิกสินค้า',
  'BUTTON:MORE': 'ดูรายละเอียดเพิ่มเติม',
  'SHOW:ALLORDERS': 'แสดงคำสั่งซื้อทั้งหมดของฉัน',
  'ROBOT:WELCOME': '..หรือคำถามที่คุณมีเกี่ยวกับลาซาด้า.',
  'ROBOT:LIVEAGENT': 'ฉันต้องการคุยกับเจ้าหน้าที่จริงๆ ไม่ใช่หุ่นยนต์',
  'PAGE:404': 'ขอโทษนะที่หน้าเว็บหายไป.',
  'WORD:ITEM': 'สินค้ารายการที่ ',
  'FEEDBACK:QUESTION': 'มีประโยชน์มั้ย?',
  'FEEDBACK:THANKS': 'ขอบคุณ!',
  'LIVE:AGENT': 'แชทกับจนท',
  'BUTTON:LOGIN': 'เข้าสู่ระบบ',
  'BUTTON:SEND': 'ส่ง',
  openOrder: () => 'โปรดเลือกคำสั่งซื้อ',
  openOrderToCancel: () => 'โปรดเลือกคำสั่งซื้อ',
  indexOrder: (o, n) => `คำสั่งซื้อที่ ${o} จาก ${n}`,
  packageDetail: (o, n) =>
    `รายละเอียดสำหรับคำสั่งซื้อ ${o} ที่มีพัสดุ ${n} ชิ้น`,
  orderDetail: (o, p, n) => `หมายเลขคำสั่งซื้อ ${o} สำหรับ ${p} มี ${n} ชิ้น`,
  packageOrder: (p, n) => `พัสดุหมายเลข ${p} ของหมายเลขคำสั่งซื้อ ${n}`,
  tracking: (p, n) =>
    `รายละเอียดการติดตามพัสดุที่ <span class="bold">${p}</span> ของหมายเลขคำสั่งซื้อ <span class="bold">${n}</span>`,
};



// WEBPACK FOOTER //
// ./src/bu/pc/locales/th-th.js